import React from "react";
import Dropdown, { DropdownProps } from "./Dropdown";
import MenuItem from "./MenuItem";
import Checkbox from "./Checkbox";
import { normalizeSalesChannelName } from "utils/normalize-sales-channel-name";
import { getSalesChannelIcon } from "utils/get-sales-channel-icon";

type MultiChannelSelectProps = {
    salesChannel: string[];
    value: string;
    onChange: (value: string) => void;
    isLoading: boolean;
} & DropdownProps;

export default function MultiChannelSelect(props: MultiChannelSelectProps) {
    const { salesChannel, value, onChange, isLoading, ...rest } = props;
    const displayedChannel = () => {
        if (value) {
            const normalized = normalizeSalesChannelName(value);
            return normalized || value;
        }

        return "All Channels";
    };

    const isAllChannelsChecked = salesChannel?.every((_channel) => value?.includes(_channel));

    const handleCheckAllChannels = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const allSalesChannels = salesChannel?.join(",");

        if (isAllChannelsChecked) {
            onChange("");
        } else {
            onChange(allSalesChannels);
        }
    };

    const handleChangeChannelFilter = (name, _value) => {
        const handlePrev = (prev) => {
            if (!prev) return _value;
            if (prev?.includes(_value)) {
                const newChannel = prev?.split(",")?.filter((item) => item !== _value);
                return newChannel.join(",");
            }
            const newChannel = [...prev?.split(","), _value];
            return newChannel.join(",");
        };

        const newValue = handlePrev(value);
        onChange(newValue);
    };

    return (
        <Dropdown
            name="filter"
            value={""}
            dropdownTriggerClassName={" "}
            handleChange={handleChangeChannelFilter}
            isLoading={isLoading}
            dropdownOptions={[
                {
                    label: (
                        <MenuItem onClick={handleCheckAllChannels}>
                            <Checkbox
                                checked={isAllChannelsChecked}
                                label={
                                    <div className="flex items-center gap-2 space-x-2">
                                        <i className="ri-box-3-line text-xl"></i>
                                        All Channels
                                    </div>
                                }
                            />
                        </MenuItem>
                    ),
                    value: null,
                },
                ...salesChannel?.map((_channel, idx) => {
                    const isChecked = value?.includes(_channel);
                    return {
                        label: (
                            <MenuItem key={idx}>
                                <Checkbox
                                    checked={isChecked}
                                    label={
                                        <div className="flex items-center gap-2 space-x-2">
                                            {getSalesChannelIcon(_channel)}
                                            {normalizeSalesChannelName(_channel)}
                                        </div>
                                    }
                                />
                            </MenuItem>
                        ),
                        value: _channel,
                    };
                }),
            ]}
            dropdown={
                <div className="flex items-center justify-between whitespace-nowrap h-[40px]  py-2 pl-3 pr-2 space-x-1 rounded-[5px] border border-slate-200">
                    <div className="flex items-center space-x-2">
                        <span className="text-[13px] whitespace-nowrap font-rocGroteskMedium capitalize">
                            {displayedChannel()}
                        </span>
                        {!!value && (
                            <i
                                onClick={(e) => {
                                    e?.stopPropagation();
                                    onChange("");
                                }}
                                className="ri-close-circle-fill text-sm text-slate-500"
                            ></i>
                        )}
                    </div>
                </div>
            }
            wholeContainerClass="!w-fit max-sm:!w-full"
            dropdownContainerClasses={`shadow-cardShadow-4 !w-full !max-w-full min-w-full border border-slate-100 rounded !max-h-fit !pt-0 !z-[1400]`}
            {...rest}
        />
    );
}
